export default __webpack_public_path__ + "static/media/032-picture.c066bc20.png";